exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.ellipsis-line-clamp-4[data-v-d8ec4d02] {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 4;\n    line-clamp: 4;\n    -webkit-box-orient: vertical;\n}\n", ""]);

// exports
